import { LoadingButton } from '@mui/lab';
import {
  ButtonProps,
  Card, CardHeader, CardProps, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { Switch } from '../../models';

const RateSwitchTableCard = styled(Card)<CardProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  margin: '20px auto',
  width: '1500px',
}));

const tableHeaders = [
  'Switch Completed',
  'Date Of Switch',
  'Account Number',
  'Company',
  'SP ID',
  'Badge Number',
  'Old Meter Config',
  'Old Rate',
  'New Meter Config',
  'New Rate',
  'Processed Date',
  'Budget Plan',
  'Payment Plan',
  'AZero',
  'To Process Date',
  'From RS',
  'For Bot',
  'Yearly Saved',
  'Estimate RG1',
  'Estimate RG5',
  'Estimate RD1',
  'Estimate 400',
  'Estimate 407',
  'Estimate Jan',
  'Estimate Feb',
  'Estimate Mar',
  'Estimate Apr',
  'Estimate May',
  'Estimate Jun',
  'Estimate Jul',
  'Estimate Aug',
  'Estimate Sep',
  'Estimate Oct',
  'Estimate Nov',
  'Estimate Dec',
  'Estimate GS1',
  'Estimate GS3',
  'Estimate GD1',
  'Estimate 600',
  'Estimate 607',
];

const RefreshButton = styled(LoadingButton)<ButtonProps>(({ theme }) => ({
  margin: '16px 0 16px 0',
}));

type Props = {
  tableData: Switch[] | undefined,
  refreshHandler: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  isLoading: boolean,
}

function RateSwitchTable({ tableData, refreshHandler, isLoading }: Props) {
  const intl = useIntl();

  return (
    <RateSwitchTableCard>
      <CardHeader
        title={intl.formatMessage({ id: 'testing-dashboard-switch-table-header' })}
      />
      <RefreshButton
        variant="contained"
        color="primary"
        loading={isLoading}
        onClick={refreshHandler}
      >
        Refresh
      </RefreshButton>
      <TableContainer component={Paper} data-testid="rateSwitchTableContainer">
        <Table aria-label="simple table" data-testid="rateSwitchTable">
          <TableHead>
            <TableRow>
              {tableHeaders.map((cell) => (<TableCell key={cell}>{cell}</TableCell>))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData && tableData.map((row) => (
              <TableRow key={`${row.DATE_OF_SWITCH}-${row.SP_ID}`}>
                {Object.entries(row).map((cell) => (
                  <TableCell key={cell[0]}>
                    <span>{cell[1]?.toString()}</span>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </RateSwitchTableCard>
  );
}

export default RateSwitchTable;
